// cleanQuestions.js

function cleanTextField(text) {
  if (Array.isArray(text)) {
    // Join fragments — keep LaTeX commands intact for KaTeX
    return text
      .filter(line => line !== "")  // remove empty trailing lines
      .join(" ")                     // join with space
      .trim();
  }
  return typeof text === "string" ? text : "";
}

export function cleanQuestions(rawQuestions) {
  if (!Array.isArray(rawQuestions)) return [];

  return rawQuestions
    .filter(q => Array.isArray(q.items) && q.items.length > 0)
    .map((q, idx) => ({
      ...q,
      id: crypto.randomUUID(),
      ind: idx + 1,
      items: q.items.map(item => {
        if (item.res?.math && Array.isArray(item.res.text)) {
          return {
            ...item,
            res: {
              ...item.res,
              text: cleanTextField(item.res.text),
            },
          };
        }
        return item;
      }),
    }));
}